export const SETDEC = 'dec/SETDEC'

export const setDec = (dec: number) => ({
	type: SETDEC,
	payload: dec
})

export type decTypes =
	ReturnType<typeof setDec>